<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

    <div fxFlex>
      <form [formGroup]="form"> 
        <mat-form-field class="width-100">
          <input 
            matInput
            #branchInput
            formControlName="branch" 
            [matAutocomplete]="branchAC" 
            [placeholder]="'LABEL_BRANCH' | translate"
            (focus)="!branchAC.isOpen && getInitialValues('branch')" 
            (blur)="checkAutocompleteObject(form, 'branch')"
            [required]="isRequired"
            >
  
          <mat-icon 
            id="id_select_branch_delete_btn"
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            (click)="branchInput.blur(); clearForm($event)"
            *ngIf="branchInput.value && !disabled"
            >
          </mat-icon>
  
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!branchInput.value"
            >
          </mat-icon>
  
          <mat-autocomplete 
            id="id_select_branch_dropdown"
            [displayWith]="displayFn" 
            #branchAC="matAutocomplete" 
            (closed)="autoCmpltClosed(); branchInput.blur()"
            (opened)="autocompleteScroll('branch','branchACRef','branchACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.branch && listData?.length == 0"
              >
              {{ 'LABEL_NO_DATA' | translate }}
            </mat-option>
  
            <mat-option
              [id]="'id_select_branch_data_' + (i+1)"
              [value]="data" 
              matTooltipPosition="right"
              *ngFor="let data of listData; let i = index" 
              [matTooltip]="data.code + ' - ' + data.description"
              >
              {{ data.code }} - {{ data.description }}
            </mat-option>
  
            <mat-option *ngIf="loading.branch" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
  
          <mat-error *ngIf="form.get('branch').hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error>
  
          <mat-error *ngIf="form.get('branch').hasError('notExisting')">
            {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_BRANCH' | translate} }}
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    
  </div>